const SDK_VERSION = "10.76.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
